const Category = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "image": "Image",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "category": "Category",

    // ERROR
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_image": "Select Image",
    "error_file_size": "Image size must be less than 5MB",
    "error_file_type": "Only JPG, JPEG and PNG images are allowed",

    // TABLE HEADER
    "table_image": "IMAGE",
    "table_name": "NAME",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

}

export default Category;